import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Persona} from 'common/src/modules/brandGuidelines/brandGuidelines.types';
import {BrandPersonasState} from './brandPersonas.types';

const initialState: BrandPersonasState = {
  data: null,
};

const brandPersonasSlice = createSlice({
  name: 'brandPersonas',
  initialState,
  reducers: {
    clearBrandPersonas: (state) => {
      state.data = null;
    },
    setBrandPersonas: (state, action: PayloadAction<Persona[]>) => {
      state.data = action.payload;
    },
  },
});

export const {
  clearBrandPersonas,
  setBrandPersonas,
} = brandPersonasSlice.actions;

export default brandPersonasSlice.reducer; 